import moment from "moment-timezone";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import shortenName from "../../helpers/shorten-name";

const iOSAppUsersColumns = [
  {
    name: "Created at",
    selector: "created_at",
    sortable: true,
    cell: (row) => {
      return row.createdAt ? moment(row.createdAt).format("M/D/YY - HHmm") : "-";
    },
    minWidth: "80px",
    maxWidth: "110px",
  },

  {
    name: "Last Login",
    selector: "last_login",
    sortable: true,
    cell: (row) => {
      return row.lastLogin ? moment(row.lastLogin).format("M/D/YY - HHmm") : "-";
    },
    minWidth: "80px",
    maxWidth: "110px",
  },
  {
    name: "Client Name",
    selector: "name",
    sortable: true,
    width: "130px",
    cell: (row) => {
      if (!row.prospectId) {
        return (
          <Tooltip
            classes={{
              tooltip: "multiline-tooltip",
            }}
            title={row.name}
          >
            <div className="two-line-content">{row.name}</div>
          </Tooltip>
        );
      }

      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.name}
        >
          <div className="two-line-content">
            <Link to={`/prospects/${row.prospectId}`} target="_blank" rel="noopener noreferrer">
              {row.name}
            </Link>
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    wrap: true,
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{row.email}</div>;
    },
  },
  {
    name: "Owner",
    selector: "owner",
    sortable: false,
    width: "130px",
    cell: (row) => row.owner ? shortenName(row.owner) : "-",
  },
];

export { iOSAppUsersColumns };
